import { isBefore } from 'date-fns';
import PanelGroup from '@/domain/model/business/PanelGroup.ts'; // noinspection JSUnresolvedVariable

// noinspection JSUnresolvedVariable
export default class Meter {
  jsonData;
  panelGroups: Array<PanelGroup>;

  constructor(jsonData) {
    this.jsonData = jsonData;
    this.panelGroups = jsonData.panel_groups.map((json) =>
      PanelGroup.fromJson(json),
    );
  }

  getJson() {
    return this.jsonData;
  }

  getId(): number {
    return this.jsonData.id;
  }

  getPlantId() {
    return this.jsonData.plant_id;
  }

  getDriverName() {
    return this.jsonData.driver_account
      ? this.jsonData.driver_account.driver_name
      : null;
  }

  getDriverAccountName() {
    return this.jsonData.driver_account
      ? this.jsonData.driver_account.display_name
      : 'Not found!';
  }

  getName() {
    return this.jsonData.name ? this.jsonData.name : 'Meter #' + this.getId();
  }

  getPeakInWatt() {
    return this.jsonData.peak_in_watt;
  }

  getOrientationInDegrees() {
    return this.jsonData.orientation_in_degrees;
  }

  getAngleInDegrees() {
    return this.jsonData.angle_in_degrees;
  }

  getHasMixedPanelOrientations() {
    return this.jsonData.has_mixed_panel_orientations === 1;
  }

  getRetiredOn(): Date {
    return new Date(this.jsonData.retired_on);
  }

  isRetired() {
    return (
      this.jsonData.retired_on !== null &&
      isBefore(new Date(this.jsonData.retired_on), new Date())
    );
  }

  operationalSinceHasPassed() {
    return (
      this.jsonData.operational_since !== null &&
      isBefore(this.getOperationalSince(), new Date())
    );
  }

  isActive() {
    return this.operationalSinceHasPassed() && !this.isRetired();
  }

  getOperationalSince(): Date {
    return new Date(this.jsonData.operational_since);
  }

  getIssues() {
    return this.jsonData.issues;
  }
}
